"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FilterableCollection_1 = require("./FilterableCollection");
/**
 * Provides a collection of {@link IResource} that can be filtered with relevant criteria.
 * @class
 */
class ResourceFilterableCollection extends FilterableCollection_1.default {
    /**
     * Initializes a new instance of the {@link ResourceFilterableCollection<T>}
     * class with initial collections of resources to filter.
     * @param {Iterable<IResource>} [resources] Initial collection of resources to filter.
     */
    constructor(resources) {
        super(resources);
    }
    /**
     * Obtains a collection of resources of a given type;
     * @param {string} iri Type of the resources.
     * @returns {ResourceFilterableCollection<T>}
     */
    ofType(iri) {
        let result = this;
        if (typeof iri === "string" && iri.length > 0) {
            result = this.narrowFiltersWith("type", iri);
        }
        return result;
    }
    /**
     * Obtains a collection of resources of a given Iri;
     * @param {string} iri Iri of the resources.
     * @returns {ResourceFilterableCollection<T>}
     */
    ofIri(iri) {
        let result = this;
        if (typeof iri === "string" && iri.length > 0) {
            result = this.narrowFiltersWith("iri", iri);
        }
        return result;
    }
    /**
     * Obtains a collection of resources being non blank nodes;
     * @returns {IResourceFilterableCollection<T>}
     */
    nonBlank() {
        return this.narrowFiltersWith("iri", new RegExp("[a-zA-Z][a-zA-Z0-9_]*:"));
    }
    /** @inheritdoc */
    createInstance(items) {
        return new ResourceFilterableCollection(items);
    }
}
exports.default = ResourceFilterableCollection;
//# sourceMappingURL=ResourceFilterableCollection.js.map